/**
 * Reducer initial state
 * @type {{pendingOperation: boolean}}
 */
const initialState = {
	pendingOperation: false
};

/**
 * Reducer managing contingent.
 *
 * @name NetworkReducer
 *
 * @param {Object} state - Current application state
 * @param {AbstractAction} action - Action to dispatch
 * @return {Object} new state
 */
export default (state = initialState, action) => {
	if (!action.isAction) {
		return state;
	}

	return action.performNetworkReducer(state);
};
